<template>
  <div class="w-100 modal-h-80">
    <div class="row no-gutters h-100">
      <div :key="slider_key" class="col-lg-6 d-none d-lg-block" v-if="!isProductImageHidden">
        <ProductSliderDetail :data="data" height_size="modal-h-80"></ProductSliderDetail>
      </div>
      <div class="col-md-12" :class="isProductImageHidden ? 'col-lg-12' : 'col-lg-6'">
        <div class="pd-panel modal-h-80">

          <!-- HEADER -->
          <div class="pd-header">
            <div class="pd-header__text">
              <p class="pd-title">{{ data.name }}</p>
              <span class="pd-category" v-if="categoryLabel">{{ categoryLabel }}</span>
            </div>
            <button type="button" class="pd-close border-form" @click="close()">
              <X :size="17" />
            </button>
          </div>

          <!-- BODY -->
          <div class="pd-body">
            <div :key="slider_key" class="d-block d-lg-none" v-if="!isProductImageHidden">
              <ProductSliderDetail :data="data" height_size="h-200px"></ProductSliderDetail>
            </div>

            <div class="pd-body__inner">

              <!-- RINGKASAN PRODUK -->
              <p class="pd-meta" v-if="hasMetaInfo">
                <span class="pd-meta__item" v-if="hasDuration">
                  <span class="font-lato">{{ durationValue }}</span> {{ durationUnit }}
                </span>
                <span class="pd-meta__item" v-if="data.guest_include > 0">
                  <span class="font-lato">{{ data.guest_include }}</span> {{ guestIncludedSuffix }}
                </span>
                <span class="pd-meta__item" v-if="tax_service != ''">{{ tax_service }}</span>
              </p>
              <p class="pd-desc" v-if="data.description">{{ data.description }}</p>

              <!-- POLICY -->
              <div class="pd-accordion border-form" v-if="data.policy != null">
                <button type="button" class="pd-accordion__head" @click="togglePolicy()">
                  <span class="pd-accordion__title">{{ data.policy.name }}</span>
                  <ChevronDown :size="16" class="pd-chevron" :class="{ 'pd-chevron--open': is_policy_open }" />
                </button>
                <div class="pd-accordion__body html-desc" v-if="is_policy_open" v-html="data.policy.description"></div>
              </div>

              <div class="pd-divider"></div>

              <!-- FORM -->
              <div id="detail-form">
                <p class="pd-step">
                  <span class="pd-step__num font-lato">{{ stepNumbers.date }}</span>
                  Select date &amp; how many
                </p>

                <div class="pd-book-card border-form">

                  <!-- DATE -->
                  <div class="pd-book-cell calendar-concierge lh-1">
                    <date-range-picker
                      class="w-100"
                      v-model="service_date.data"
                      auto-apply
                      :ranges="false"
                      opens="center"
                      :min-date="service_date.min_date"
                      :max-date="service_date.max_date"
                      :single-date-picker="true"
                      @toggle="dateToggleDetail">
                      <template v-slot:input="picker">
                        <div class="pd-book-row pd-book-row--stack">
                          <span class="pd-book-row__label">Date</span>
                          <span class="pd-book-row__value">
                            <span class="font-lato">{{ formatDateFilter(service_date.data.startDate) }}</span>
                            <ChevronDown :size="16" class="pd-chevron"
                              :class="{ 'pd-chevron--open': service_date.show_detail }" />
                          </span>
                        </div>
                      </template>
                      <template #date="calendar_date">
                        <div class="calendar-concierge-custom-date">
                          <p class="font-lato text-12 lh-1 mb-0">{{ formatDateNumber(calendar_date.date) }}</p>
                        </div>
                      </template>
                    </date-range-picker>
                  </div>

                  <!-- QUANTITY -->
                  <div class="pd-book-cell pd-book-cell--qty">
                    <div class="pd-book-row pd-book-row--stack">
                      <span class="pd-book-row__label">How many?</span>
                      <div class="pd-stepper pd-stepper--wide">
                        <button type="button" class="pd-stepper__btn" :disabled="product_qty <= 1"
                          @click="changeProductQty('min')">
                          <Minus :size="14" />
                        </button>
                        <span class="pd-stepper__value">
                          <span class="pd-stepper__num font-lato">{{ product_qty }}</span>
                          <span class="pd-stepper__unit">{{ qtyUnitText }}</span>
                        </span>
                        <button type="button" class="pd-stepper__btn" @click="changeProductQty('plus')">
                          <Plus :size="14" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- BUTTON -->
                <state-button class="pd-check" size="lg" block
                  :variant="result_check_avb != 'avb' ? 'primary' : 'primary-outline'"
                  :click="checkAvb">Check availability</state-button>

                <!-- RESULT -->
                <div class="w-100" id="time">
                  <template v-if="isResultReady">

                    <!-- SERVICE TIME -->
                    <div class="pd-section pd-reveal">
                      <p class="pd-step">
                        <span class="pd-step__num font-lato">{{ stepNumbers.time }}</span>
                        Select service time
                      </p>
                      <div class="pd-slot-grid" v-if="data.use_schedule">
                        <button type="button" class="pd-slot border-form" v-for="slot in serviceTimeSlots" :key="slot.id"
                          :class="{ 'pd-slot--active': slot.is_active, 'pd-slot--full': slot.is_full }"
                          :disabled="slot.is_full"
                          @click="timeSelect(slot.source)">
                          <span class="pd-slot__time font-lato">{{ slot.label }}</span>
                          <span class="pd-slot__note" v-if="slot.is_full">Full booked</span>
                          <span class="pd-slot__note" v-else-if="slot.note_count != null">
                            <span class="font-lato">{{ slot.note_count }}</span> available
                          </span>
                        </button>
                      </div>
                      <div class="pd-time" v-else>
                        <v-timepicker
                          v-model="service_time.manual_data"
                          :hour-range="service_time.manual_data_range.hour"
                          :minute-range="service_time.manual_data_range.minute"
                          @input="onInputManualTime()"
                          hide-disabled-hours
                          hide-disabled-minutes
                          hide-clear-button
                          close-on-complete
                          format="HH:mm"
                          :minute-interval="10"
                          hour-label="Hour"
                          minute-label="Minute"
                          class="time-picker-manual"
                          @close="timeSelectManual()" />
                        <p class="pd-time__note" v-if="!isSpaModule">
                          <span class="font-lato">{{ result_filter.realtime_avb }}</span> available
                        </p>
                      </div>
                    </div>

                    <!-- PLACE -->
                    <div class="pd-section pd-reveal" id="place" v-if="isPlaceStepShown">
                      <p class="pd-step">
                        <span class="pd-step__num font-lato">{{ stepNumbers.place }}</span>
                        Choose a place for the spa
                      </p>
                      <div class="pd-choice-row">
                        <button type="button" class="pd-choice border-form" v-for="plc in place.list" :key="plc"
                          :class="{ 'pd-choice--active': plc == place.data }"
                          @click="placeSelect(plc)">{{ plc }}</button>
                      </div>
                    </div>

                    <!-- GENDER -->
                    <div class="pd-section pd-reveal" id="specialist" v-if="isGenderStepShown">
                      <p class="pd-step">
                        <span class="pd-step__num font-lato">{{ stepNumbers.gender }}</span>
                        Therapist preference
                      </p>
                      <div class="pd-toggle-card border-form">
                        <div class="pd-toggle-row" @click="genderToggleDetail()">
                          <p class="pd-toggle-label">Preferred gender of therapist?</p>
                          <span class="pd-switch" :class="{ 'pd-switch--on': specialist.show_detail }">
                            <span class="pd-switch__knob"></span>
                          </span>
                        </div>
                        <div class="pd-choice-row pd-reveal" v-if="specialist.show_detail">
                          <button type="button" class="pd-choice border-form" v-for="gender_therapist in specialist.list"
                            :key="gender_therapist"
                            :class="{ 'pd-choice--active': gender_therapist == specialist.data }"
                            @click="genderSelect(gender_therapist)">{{ gender_therapist }}</button>
                        </div>
                      </div>
                    </div>

                    <!-- GUEST PER ITEM: informasi sekunder, ditaruh paling bawah tanpa nomor langkah -->
                    <div class="pd-section pd-guest pd-reveal" v-if="isGuestPerQtyShown">
                      <p class="pd-subhead">Guests per item</p>
                      <p class="pd-hint">Let us know how many people will actually join. Max
                        <span class="font-lato">{{ maxGuestPerQty }}</span> guest per item.</p>
                      <div class="pd-guest-card border-form">
                        <div class="pd-guest-row" v-for="row in guestPerQtyRows" :key="row.index">
                          <span class="pd-guest-badge font-lato">{{ row.index + 1 }}</span>
                          <p class="pd-guest-name">{{ row.label }}</p>
                          <div class="pd-stepper pd-stepper--sm pd-stepper--ghost">
                            <button type="button" class="pd-stepper__btn border-form" :disabled="row.guest <= 1"
                              @click="changeGuestPerQty(row.index,'min')">
                              <Minus :size="13" />
                            </button>
                            <span class="pd-stepper__num font-lato">{{ row.guest }}</span>
                            <button type="button" class="pd-stepper__btn border-form" :disabled="row.guest >= maxGuestPerQty"
                              @click="changeGuestPerQty(row.index,'plus')">
                              <Plus :size="13" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>

                  <!-- BELUM DICEK -->
                  <div class="pd-placeholder border-form" v-else-if="isCheckPending">
                    <div class="pd-placeholder__icon">
                      <Search :size="20" />
                    </div>
                    <p class="pd-placeholder__title">Check the availability first</p>
                    <p class="pd-placeholder__text">Pick your date and quantity above, then tap <b>Check availability</b> to see the service times we still have open.</p>
                  </div>

                  <!-- GAGAL -->
                  <AvailabilityAlert v-else
                    :reason="alertReason"
                    :service-date="service_date.data.startDate"
                    :qty="product_qty"
                    :unit="data.unit || {}"
                    :is-schedule="!!data.use_schedule"
                    :can-try-next-day="canTryNextDay"
                    :error-message="requestErrorMessage"
                    @change-qty="applySuggestedQty"
                    @next-day="checkNextDay" />
                </div>
              </div>
            </div>
          </div>

          <!-- FOOTER -->
          <div class="pd-footer" v-if="isResultReady">
            <div class="pd-footer__price">
              <p class="pd-footer__label">Total price</p>
              <span class="pd-footer__value font-lato">
                <template v-if="total_price.display.final > 0">{{ $formatCurrency(total_price.display.final) }}</template>
                <template v-else>-</template>
              </span>
              <div class="pd-footer__sub" v-if="hasPriceDiscount">
                <span class="pd-footer__old font-lato">{{ $formatCurrency(total_price.display.base) }}</span>
                <span class="pd-save-chip">Save <span class="font-lato">{{ total_price.display.promotion_pct }}</span>%</span>
              </div>
            </div>
            <state-button class="pd-footer__btn" size="lg" variant="primary"
              :disabled="!button_book_valid" :click="addToCart">Add to cart</state-button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DateRangePicker from 'vue2-daterange-picker';
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
  import ProductSliderDetail from './ProductSliderDetail';
  import moment from 'moment';
  import {
    get
  } from '@/services/index.js';
  import {
    mapGetters,
    mapMutations
  } from 'vuex';
  import { normalizeGuestList } from '@/utils/activityCart.js';
  import {
    UNAVAILABLE_REASON,
    getScheduleUnavailableReason,
    getStandardUnavailableReason
  } from '@/utils/activityAvailability.js';
  import AvailabilityAlert from '@/components/v2/activity/AvailabilityAlert.vue';
  import { ChevronDown, Minus, Plus, Search, X } from 'lucide-vue';

  const DAY_NAMES = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']

  export default {
    props:{
      data:{
        type: Object,
        default: () => {}
      },
      general_data:{
        type: Object,
        default: () => {}
      },
      window_width:{
        type: Number,
        default: 0
      },
      page_source:{
        type: String,
        default: 'general'
      }
    },
    components: {
      DateRangePicker,
      ProductSliderDetail,
      AvailabilityAlert,
      ChevronDown,
      Minus,
      Plus,
      Search,
      X
    },
    data() {
      return {
        slider_key: 0,
        is_policy_open: false,
        product_qty: 1,
        guest_per_qty: [],
        service_date: {
          show_detail: false,
          data: {
            startDate: moment().toDate(),
            endDate: moment().toDate(),
          },
          min_date: moment().toDate(),
          max_date: null
        },
        result_check_avb: '',
        unavailable_reason: null,
        lock_qty_date: '',
        result_filter:{},
        service_time: {
          list: [],
          data: {},
          manual_data: {
            HH: '--',
            mm: '--'
          },
          manual_data_range: {
            hour: [[0,23]],
            minute: [[0,59]],
            minute_start: "00",
            minute_end: "60",
          }
        },
        place: {
          list: [],
          data: ''
        },
        specialist: {
          show_detail: false,
          list: ['Male', 'Female'],
          data: ''
        },
        total_price: {
          final: 0,
          base: 0,
          promotion_amount: 0,
          promotion_pct: 0,
          taxes: 0,
          services: 0,
          source: {},
          display:{
            base: 0,
            final: 0,
            promotion_pct: 0
          }
        }
      }
    },
    computed: {
      ...mapGetters([
        'getMerchant',
        'getActivityTrxPromoCode',
        'getActivityTrxMasterAvb',
        'getActivityTrxProducts',
        'getBeFilter',
        'getActiveHotelModule'
      ]),
      isProductImageHidden(){
        return this.$isProductImageHidden(this.general_data)
      },
      page_module(){
        if(this.page_source == 'general'){
          if(this.$route.meta.sub_module) return this.$route.meta.sub_module
          return ''
        }else{
          if(this.general_data.pos_type == 'SPA') return 'concierge-spa'
          return 'hotel-activity'
        }
      },
      isSpaModule(){
        if(this.$isNotEmptyV2(this.general_data.pos_type)) return this.general_data.pos_type == 'SPA'
        return false
      },
      api_module(){
        if(this.page_module == 'hotel-activity') return 'CORE_HOTEL'
        return 'CONCIERGE'
      },
      pos_code() {
        if(this.page_module == 'hotel-activity') return this.$route.params.pos_code
        return 'spa'
      },
      categoryLabel() {
        const category = this.data.category
        return category && category.name ? category.name : ''
      },
      // Angka dipisah dari satuannya supaya bisa dibungkus class font-lato di template
      guestIncludedSuffix() {
        const total_guest = Number(this.data.guest_include)
        return `${this.$pluralWord(total_guest, 'guest')} included`
      },
      hasDuration() {
        return this.data.duration_type != 'NO_SHOW' && this.$isNotEmpty(this.data.duration_text)
      },
      durationValue() {
        return this.hasDuration ? this.data.duration_text : ''
      },
      durationUnit() {
        if (this.data.duration_type == 'HOUR') return 'Hour(s)'
        if (this.data.duration_type == 'MINUTE') return 'Minute(s)'
        return ''
      },
      hasMetaInfo() {
        return this.hasDuration || this.data.guest_include > 0 || this.tax_service != ''
      },
      // Unit produk diisi bebas oleh merchant (Person / Pax / Treatment), jadi butuh fallback netral
      qtyUnitText() {
        const unit = this.data.unit
        const unit_name = unit && unit.unit ? unit.unit.toLowerCase() : 'item'
        return this.$pluralWord(this.product_qty, unit_name)
      },
      maxGuestPerQty() {
        return this.data.guest_include > 0 ? Number(this.data.guest_include) : 1
      },
      // Hanya relevan saat ada lebih dari 1 guest per item, di bawah itu tidak ada yang bisa diubah
      isGuestPerQtyShown() {
        return this.data.guest_include > 1
      },
      guestPerQtyRows() {
        return this.guest_per_qty.map((guest, index) => ({
          index,
          guest,
          label: this.data.name
        }))
      },
      serviceTimeSlots() {
        return this.service_time.list.map(time => {
          const is_full = time.realtime_avb < this.product_qty
          const show_count = !is_full && !this.isSpaModule

          return {
            id: time.id,
            source: time,
            label: this.$customFormatDateTime(time.schedule_start, 'HH:mm:ss', 'hh:mm A'),
            is_full: is_full,
            is_active: time.id == this.service_time.data.id,
            note_count: show_count ? time.realtime_avb : null
          }
        })
      },
      isCheckPending() {
        return this.result_check_avb == ''
      },
      isResultReady() {
        return this.result_check_avb == 'avb' && this.current_qty_date == this.lock_qty_date
      },
      isServiceTimeSelected() {
        if (this.data.use_schedule) return this.$isNotEmptyV2(this.service_time.data.id)
        const { HH, mm } = this.service_time.manual_data
        return HH != '' && HH != '--' && mm != '' && mm != '--'
      },
      isPlaceStepShown() {
        return this.general_data.use_place_choices && this.isServiceTimeSelected
      },
      isGenderStepShown() {
        if (!this.general_data.use_gender_therapist_choices) return false
        if (this.general_data.use_place_choices) return this.place.data != ''
        return this.isServiceTimeSelected
      },
      // Guest, place, dan gender bersifat opsional, jadi nomor langkahnya dihitung berurutan
      stepNumbers() {
        const steps = {}
        let step = 0
        steps.date = ++step
        steps.time = ++step
        if (this.general_data.use_place_choices) steps.place = ++step
        if (this.general_data.use_gender_therapist_choices) steps.gender = ++step
        return steps
      },
      hasPriceDiscount() {
        return this.total_price.display.final > 0 && this.total_price.display.promotion_pct > 0
      },
      tax_service() {
        let ts = this.data.tax_services
        if (ts) {
          if (ts.calculation_type == 'INCLUDE') return 'Includes taxes and services'
          return 'Excludes taxes and service'
        } else {
          return ''
        }
      },
      button_book_valid() {
        let is_valid = true
        let use_schedule = this.data.use_schedule
        let use_place = this.general_data.use_place_choices
        let use_gender = this.general_data.use_gender_therapist_choices
        let time_form_sch = this.service_time.data.id
        let time_form_manual = this.service_time.manual_data.HH == '--' || this.service_time.manual_data.mm == '--'
        let place_form = this.place.data
        let gender_select = this.specialist.show_detail
        let gender_form = this.specialist.data
        let gender_valid = !gender_select || (gender_select && gender_form != '')

        if(use_schedule && !time_form_sch) is_valid = false
        else if(!use_schedule && time_form_manual) is_valid = false
        else if(use_place && place_form == '') is_valid = false
        else if(use_gender && !gender_valid) is_valid = false

        return is_valid
      },
      current_qty_date(){
        return `${this.product_qty} - ${this.$formatDate(this.service_date.data.startDate)}`
      },
      isFilterChanged() {
        return this.result_check_avb == 'avb' && this.current_qty_date != this.lock_qty_date
      },
      alertReason() {
        if (this.isFilterChanged) return { code: UNAVAILABLE_REASON.FILTER_CHANGED }
        if (this.result_check_avb == 'no-avb' && this.unavailable_reason) return this.unavailable_reason
        return { code: UNAVAILABLE_REASON.REQUEST_FAILED }
      },
      requestErrorMessage() {
        const is_api_message = this.result_check_avb != 'avb' && this.result_check_avb != 'no-avb'
        return is_api_message ? String(this.result_check_avb) : ''
      },
      serviceDayName() {
        return DAY_NAMES[moment(this.service_date.data.startDate).day()]
      },
      isServiceDayClosed() {
        const gd = this.general_data
        if (!gd || !gd.use_daily_operational_hour) return false
        return gd[`sale_${this.serviceDayName}`] === false
      },
      canTryNextDay() {
        const { max_date } = this.service_date
        if (!max_date) return true
        const next_day = moment(this.service_date.data.startDate).add(1, 'd')
        return next_day.isSameOrBefore(moment(max_date), 'day')
      }
    },
    watch:{
      'product_qty'(){
        this.syncGuestPerQty()
      },
      result_check_avb(){
        if(this.result_check_avb == 'avb'){
          this.lock_qty_date = `${this.product_qty} - ${this.$formatDate(this.service_date.data.startDate)}`
        }else{
          this.lock_qty_date = ''
        }
      }
    },
    mounted(){
      this.syncGuestPerQty()
      this.loadFirstData()
    },
    methods: {
      // GENERAL
      ...mapMutations(['setTrxActivityProduct']),
      formatDateNumber(value) {
        return moment(value).format("D")
      },
      formatDateFilter(value) {
        return moment(value).format("D MMM YYYY")
      },
      close() {
        this.$emit('close')
      },
      togglePolicy() {
        this.is_policy_open = !this.is_policy_open
      },
      filterFormGoTop(id) {
        setTimeout(() => {
          this.$smoothScroll(id)
        }, 100)
      },

      loadFirstData(){
        setTimeout(() => {
          this.slider_key++
        }, 100)

        const isAdditionalServiceCart = this.getMerchant.additional_appearance === 'CART' && this.page_source == 'additional_service'
        if(isAdditionalServiceCart){
          this.service_date.min_date = moment(this.getBeFilter.date.check_in).format("YYYY-MM-DD")
          this.service_date.max_date = moment(this.getBeFilter.date.check_out).format("YYYY-MM-DD")
          this.service_date.data = {
            startDate: this.service_date.min_date,
            endDate: this.service_date.min_date,
          }
        }else{
          if(this.data.use_schedule){
            this.checkTodayAvbIfSchedule()
          }
        }

      },
      checkTodayAvbIfSchedule(){
        let copy_schedule = this.$deepCopy(this.data.schedule)
        let avb_sch = [] //available schedule
        let today = moment()
        avb_sch = copy_schedule.filter(x=>{
          let sch_today = moment(x.schedule_start,"HH:mm:ss").toDate()
          if(x.cut_off > 0){
            sch_today = moment(sch_today).subtract(x.cut_off,'hours')
          }
          if(moment(today).isBefore(sch_today)){
            return x
          }else{
            return false
          }
        })
        if(avb_sch.length == 0){
          this.service_date.data = {
            startDate: moment().add(1,'d').toDate(),
            endDate: moment().add(1,'d').toDate(),
          }
          this.service_date.min_date = moment().add(1,'d').toDate()
        }else{
        }
      },


      // QUANTITY FUNCTION
      changeProductQty(action) {
        if (!(action == 'min' && this.product_qty == 1)) {
          if (action == 'min') this.product_qty--
          else this.product_qty++
        }
      },

      // GUEST PER QTY FUNCTION
      syncGuestPerQty() {
        this.guest_per_qty = normalizeGuestList(this.guest_per_qty, this.product_qty, this.maxGuestPerQty)
      },
      changeGuestPerQty(index, action) {
        const current_guest = this.guest_per_qty[index]
        if (action == 'min' && current_guest <= 1) return
        if (action == 'plus' && current_guest >= this.maxGuestPerQty) return

        this.$set(this.guest_per_qty, index, action == 'min' ? current_guest - 1 : current_guest + 1)
      },
      setTotalPrice(data=null){
        if(data == null){
          this.total_price = {
            final: 0,
            base: 0,
            promotion_amount: 0,
            promotion_pct: 0,
            taxes: 0,
            services: 0,
            source: {},
            display:{
              base: 0,
              final: 0,
              promotion_pct: 0
            }
          }
        }else{
          let calculatePromotion = (base_price,promotion_pct) => {
            let promotion_amount = base_price*(promotion_pct/100)
            let final = base_price-promotion_amount
            return final
          }

          const basePrice = this.$getConciergeBasePrice(data)

          this.total_price = {
            final: data.price_sell_final_with_tax_service*Number(this.product_qty),
            base: basePrice*Number(this.product_qty),
            promotion_amount: data.promotion_amount*Number(this.product_qty),
            promotion_pct: data.promotion_pct,
            taxes: data.tax_amount*Number(this.product_qty),
            services: data.service_amount*Number(this.product_qty),
            source: data,
            display:{
              base: basePrice*Number(this.product_qty),
              final: data.price_sell_final_with_tax_service*Number(this.product_qty),
              promotion_pct: Math.round(data.promotion_pct)
            }
          }
        }
      },

      // DATE
      dateToggleDetail(show) {
        this.service_date.show_detail = show
        if (show){
          this.filterFormGoTop('time')
        }
      },

      // TIME
      timeSelect(time) {
        if(time.realtime_avb >= this.product_qty){
          this.service_time.data = time
          this.setTotalPrice(time.price)
          if(this.general_data.use_place_choices){
            this.filterFormGoTop('place')
          }else if(this.general_data.use_gender_therapist_choices){
            this.filterFormGoTop('specialist')
          }
        }
      },
      timeSelectManual(){
        let form_valid = this.service_time.manual_data.HH != '' && this.service_time.manual_data.mm != ''
        if(form_valid){
          if(this.general_data.use_place_choices){
            this.filterFormGoTop('place')
          }else if(this.general_data.use_gender_therapist_choices){
            this.filterFormGoTop('specialist')
          }
        }
      },

      // PLACE
      placeSelect(place) {
        this.place.data = place
        if(this.general_data.use_gender_therapist_choices){
          this.filterFormGoTop('specialist')
        }
      },

      // GENDER
      genderToggleDetail(show) {
        this.specialist.show_detail = !this.specialist.show_detail
        this.filterFormGoTop('specialist')
      },
      genderSelect(gender) {
        this.specialist.data = gender
      },

      // ADVANCE
      checkAvb() {
        return new Promise((success, fail) => {
          this.result_check_avb = ''
          this.unavailable_reason = null
          this.service_time = {
            list: [],
            data: {},
            manual_data: {
              HH: '--',
              mm: '--'
            },
            manual_data_range: {
              hour: [[0,23]],
              minute: [[0,59]],
              minute_start: "00",
              minute_end: "60",
            }
          }
          this.setDefaultTimeRange()
          this.place = {
            list: [],
            data: ''
          },
          this.specialist = {
            show_detail: false,
            list: ['Male', 'Female'],
            data: ''
          }

          let params = {
            merchant_id: this.getMerchant.id,
            qty: this.product_qty,
            date: moment(this.service_date.data.startDate).format("YYYY-MM-DD")
          }
          if(this.getActivityTrxPromoCode != ''){
            params.promo_code = this.getActivityTrxPromoCode
          }

          let api_url = this.page_module == 'concierge-spa' ? `spa/product/${this.data.id}` : `merchant-pos/${this.general_data.id}/product/${this.data.id}`

          get(this.api_module, api_url, params).then(response => {
            let res = response.data
            if (res.success) {
              this.result_filter = res.data
              this.setTotalPrice(res.data.price)

              // SCHEDULE
              if(this.data.use_schedule){
                const schedules = res.data.schedule || []
                this.service_time.list = this.filterOpenSchedules(this.$deepCopy(schedules))
                this.setupServiceTimeList()

                this.unavailable_reason = getScheduleUnavailableReason({
                  schedules,
                  openSchedules: this.service_time.list,
                  qty: this.product_qty,
                  isClosedDay: this.isServiceDayClosed
                })
                this.result_check_avb = this.unavailable_reason ? 'no-avb' : 'avb'

                const is_time_have_dynamic_price = schedules.some(x => x.price_by_pax && x.price_by_pax.length > 0)
                if(is_time_have_dynamic_price) {
                  this.setTotalPrice()
                }
              }
              // STANDART
              else{
                if(this.$isNotEmpty(res.data.open_order_time) && this.$isNotEmpty(res.data.open_order_time)) this.setupServiceTimeNonSchedule(res.data)

                this.result_filter.realtime_avb = res.data.availability
                let vuex_master_avb = this.getActivityTrxMasterAvb
                let service_date = moment(this.service_date.data.startDate).format("YYYY-MM-DD")
                if(this.result_filter.use_master_availability){

                  let checkAvb = (master_avb) => {
                    let total_per_combination = master_avb.map(avb=> Math.floor(Number(avb.realtime_avb)/Number(avb.qty)))
                    let total_combination = Math.min(...total_per_combination)
                    return total_combination
                  }
                  this.result_filter.master_availability_reference_data = this.result_filter.master_availability_reference_data.map(mvb => {

                    mvb.realtime_avb = mvb.availability

                    let record_mvb = vuex_master_avb.findIndex(v_mvb=>v_mvb.reference_id == mvb.reference_id)
                    if(record_mvb != -1){

                      let record_mvb_date = vuex_master_avb[record_mvb].dates.findIndex(d_mvb=>d_mvb.date == service_date)
                      if(record_mvb_date != -1) {

                        let record_product_vuex = this.getActivityTrxProducts.findIndex(prd=>prd.original_data.id == this.data.id)
                        if(record_product_vuex != -1){

                          let record_master_avb_in_product = this.getActivityTrxProducts[record_product_vuex].original_data.master_availability_reference_data.findIndex(x=>x.reference_id == mvb.reference_id)
                          if(record_master_avb_in_product != -1){

                            let master_avb_in_product = Number(this.getActivityTrxProducts[record_product_vuex].original_data.master_availability_reference_data[record_master_avb_in_product].qty)
                            let taken_avb_from_master = (master_avb_in_product*this.getActivityTrxProducts[record_product_vuex].qty)
                            mvb.realtime_avb = vuex_master_avb[record_mvb].dates[record_mvb_date].availability + taken_avb_from_master
                          }

                        }else{
                          mvb.realtime_avb = vuex_master_avb[record_mvb].dates[record_mvb_date].availability
                        }
                      }
                    }
                    return mvb
                  })
                  this.result_filter.realtime_avb = checkAvb(this.result_filter.master_availability_reference_data)
                }else{
                  let master_avb = vuex_master_avb.find(x=>x.reference_id == this.result_filter.ga_concierge_id)
                  if(master_avb){
                    let date_avb = master_avb.dates.find(x=>x.date == service_date)
                    if(date_avb){
                      this.result_filter.realtime_avb = date_avb.availability
                    }
                  }
                }

                this.unavailable_reason = getStandardUnavailableReason({
                  product: this.result_filter,
                  realtimeAvailability: this.result_filter.realtime_avb,
                  qty: this.product_qty
                })
                this.result_check_avb = this.unavailable_reason ? 'no-avb' : 'avb'

              }

              if(this.general_data.use_place_choices){
                this.place.list = this.general_data.place_choices
              }

              this.result_filter.product_merchant_pos = this.$selectActiveMerchantPos(this.result_filter.product_merchant_pos, this.page_source);

            } else {
              this.result_check_avb = res.message
            }
            this.filterFormGoTop('time')
            success()
          })
        })
      },
      // Sesi yang jam mulainya dikurangi cut-off masih di depan waktu sekarang
      filterOpenSchedules(schedules) {
        const now = moment()
        return schedules.filter(sch => {
          const session_start = moment(sch.schedule_start, 'HH:mm:ss')
          let booking_deadline = moment(this.service_date.data.startDate).set({
            hour: session_start.hours(),
            minute: session_start.minutes()
          })
          if (sch.cut_off > 0) booking_deadline = booking_deadline.subtract(sch.cut_off, 'hours')
          return now.isBefore(booking_deadline)
        })
      },
      applySuggestedQty(qty) {
        this.product_qty = qty
        this.checkAvb()
      },
      checkNextDay() {
        const next_day = moment(this.service_date.data.startDate).add(1, 'd').toDate()
        this.service_date.data = {
          startDate: next_day,
          endDate: next_day
        }
        this.checkAvb()
      },
      setupServiceTimeList(){
        let vuex_master_avb = this.getActivityTrxMasterAvb

        let checkAvb = (master_avb) => {
          let total_per_combination = master_avb.map(avb=> Math.floor(Number(avb.realtime_avb)/Number(avb.qty)))
          let total_combination = Math.min(...total_per_combination)
          return total_combination
        }

        let service_date = moment(this.service_date.data.startDate).format("YYYY-MM-DD")

        this.service_time.list = this.service_time.list.map(sch=>{
          sch.realtime_avb = sch.availability
          if(sch.use_master_availability){
            sch.master_availability_reference_data = sch.master_availability_reference_data.map(mvb => {

              mvb.realtime_avb = mvb.availability

              let record_mvb = vuex_master_avb.findIndex(v_mvb=>v_mvb.reference_id == mvb.reference_id)
              if(record_mvb != -1){

                let record_mvb_date = vuex_master_avb[record_mvb].dates.findIndex(d_mvb=>d_mvb.date == service_date)
                if(record_mvb_date != -1) {

                  let record_product_vuex = this.getActivityTrxProducts.findIndex(prd=>prd.original_data.id == this.data.id)
                  if(record_product_vuex != -1){

                    let record_master_avb_in_product = this.getActivityTrxProducts[record_product_vuex].service_time.master_availability_reference_data.findIndex(x=>x.reference_id == mvb.reference_id)
                    if(record_master_avb_in_product != -1){

                      let master_avb_in_product = Number(this.getActivityTrxProducts[record_product_vuex].service_time.master_availability_reference_data[record_master_avb_in_product].qty)
                      let taken_avb_from_master = (master_avb_in_product*this.getActivityTrxProducts[record_product_vuex].qty)
                      mvb.realtime_avb = vuex_master_avb[record_mvb].dates[record_mvb_date].availability + taken_avb_from_master
                    }

                  }else{
                    mvb.realtime_avb = vuex_master_avb[record_mvb].dates[record_mvb_date].availability
                  }
                }
              }
              return mvb
            })
            sch.realtime_avb = checkAvb(sch.master_availability_reference_data)
          }else{
            let master_avb = vuex_master_avb.find(x=>x.reference_id == sch.id)
            if(master_avb){
              let date_avb = master_avb.dates.find(x=>x.date == service_date)
              if(date_avb){
                sch.realtime_avb = date_avb.availability
              }
            }
          }
          return sch
        })
      },
      setupServiceTimeNonSchedule(data){
        let time_start = moment(data.open_order_time,'HH:mm:ss')
        let hour_start = time_start.format("H")
        let minute_start = time_start.format("mm")
        let time_end = moment(data.close_order_time,'HH:mm:ss')
        let hour_end = time_end.format("H")
        let minute_end = time_end.format("mm")

        if(time_start.isBefore(time_end,'hour')){
          this.service_time.manual_data_range.minute_start = Number(minute_start)
          this.service_time.manual_data_range.minute_end = Number(minute_end)
          let new_hour_end = Number(hour_end)
          if(minute_end == '00'){
            new_hour_end--
          }
          this.service_time.manual_data_range.hour = [[hour_start,new_hour_end]]
        }
      },
      setDefaultTimeRange(){
        const gd = this.general_data
        if(!gd) return

        let startTime = null
        let endTime = null

        if(gd.use_daily_operational_hour){
          const dayName = this.serviceDayName

          if(gd[`sale_${dayName}`] === false){
            // Day is not a sale day, default to full range 00:00 - 23:59
            this.service_time.manual_data_range.hour = [[0,23]]
            this.service_time.manual_data_range.minute = [[0,59]]
            this.service_time.manual_data_range.minute_start = 0
            this.service_time.manual_data_range.minute_end = 59
            return
          }else{
            startTime = gd[`time_start_${dayName}`]
            endTime = gd[`time_end_${dayName}`]
          }
        }else{
          startTime = gd.time_start
          endTime = gd.time_end
        }

        if(!startTime || !endTime) return

        const tStart = moment(startTime, 'HH:mm:ss')
        const tEnd = moment(endTime, 'HH:mm:ss')
        const hourStart = Number(tStart.format('H'))
        const minuteStart = Number(tStart.format('mm'))
        const hourEnd = Number(tEnd.format('H'))
        const minuteEnd = Number(tEnd.format('mm'))

        if(tStart.isBefore(tEnd, 'hour')){
          this.service_time.manual_data_range.minute_start = minuteStart
          this.service_time.manual_data_range.minute_end = minuteEnd
          let adjustedHourEnd = hourEnd
          if(minuteEnd === 0){
            adjustedHourEnd--
          }
          this.service_time.manual_data_range.hour = [[hourStart, adjustedHourEnd]]
        }
      },
      onInputManualTime(){
        let {minute_start, minute_end} = this.service_time.manual_data_range
        let minute_not_standart = minute_start > 0 || minute_end > 0

        if(minute_not_standart){

          let {HH,mm} = this.service_time.manual_data;
          let is_first_hour_selected = Number(HH) == this.service_time.manual_data_range.hour[0][0]
          let is_last_hour_selected = Number(HH) == this.service_time.manual_data_range.hour[0][1]

          if(is_first_hour_selected && minute_start > 0){

            if(mm != '' && Number(mm) < minute_start){
              this.service_time.manual_data.mm = '--'
            }
            this.service_time.manual_data_range.minute = [[minute_start,60]]

          }else if(is_last_hour_selected && minute_end > 0){

            if(mm != '' && Number(mm) > minute_end){
              this.service_time.manual_data.mm = '--'
            }
            this.service_time.manual_data_range.minute = [[0,minute_end]]

          }else{
            this.service_time.manual_data_range.minute = [[0,60]]
          }
        }
      },
      addToCart() {
        return new Promise((success, fail) => {
          let params_to_vuex = {
            product: this.result_filter,
            qty: this.product_qty,
            date: this.service_date.data.startDate,
            time: {},
            place: this.place.data,
            gender: !this.general_data.use_gender_therapist_choices ? '' : this.specialist.data == '' ? 'Random' : this.specialist.data,
            base_price: this.total_price,
            guest_list: this.guest_per_qty.slice(),
            page_module: this.page_module == 'concierge-spa' ? this.general_data.merchant_pos_id : this.general_data.id
          }

          if(this.page_source != 'general') params_to_vuex.page_module = this.page_source

          if(this.result_filter.use_schedule){
            params_to_vuex.time = this.service_time.data
          }else{
            params_to_vuex.time = {
              schedule_start: `${this.service_time.manual_data.HH}:${this.service_time.manual_data.mm}:00`
            }
          }

          setTimeout(() => {
            this.setTrxActivityProduct(params_to_vuex)
            this.close()
            success()
          }, 500)
        })
      },
      resetFormDetail() {
        this.is_policy_open = false,
        this.product_qty = 1,
        this.guest_per_qty = [],
        this.service_date = {
          show_detail: false,
          data: {
            startDate: moment().toDate(),
            endDate: moment().toDate(),
          },
          min_date: moment().toDate(),
        },
        this.result_check_avb = '',
        this.unavailable_reason = null,
        this.service_time = {
          list: [],
          data: {},
          manual_data: {
            HH: '',
            mm: ''
          },
          manual_data_range: {
            hour: [[0,23]],
            minute: [[0,59]],
            minute_start: "00",
            minute_end: "60",
          }
        },
        this.place = {
          list: [],
          data: ''
        },
        this.specialist = {
          show_detail: false,
          list: ['Male', 'Female'],
          data: ''
        }
      }
    }
  }

</script>
<style>
  /* Token visual: radius kotak 12px (sama dengan .g-btn global), pill 999px, lingkaran 50%.
     Semua garis kotak memakai class utilitas .border-form (#CCC, !important). */

  /* ---------- SHELL: header tetap, body scroll, footer menempel ---------- */
  .pd-panel {
    display: flex;
    flex-direction: column;
    background: #fff;
  }

  .pd-header {
    flex: 0 0 auto;
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 14px 20px;
    border-bottom: 1px solid #eceef1;
  }

  .pd-header__text {
    flex: 1 1 auto;
    min-width: 0;
  }

  .pd-title {
    margin: 0 0 2px;
    font-size: 18px;
    font-weight: 600;
    line-height: 1.3;
    color: #16161d;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .pd-category {
    display: inline-block;
    color: var(--merchant-primary-color);
    font-size: 12px;
    font-weight: 400;
  }

  .pd-close {
    flex: 0 0 auto;
    width: 34px;
    height: 34px;
    display: grid;
    place-items: center;
    border-radius: 50%;
    background: #fff;
    color: #1a1a2e;
    cursor: pointer;
    transition: background 0.15s;
  }

  .pd-close:hover {
    background: #f4f5f7;
  }

  .pd-body {
    flex: 1 1 auto;
    overflow-y: auto;
  }

  .pd-body__inner {
    padding: 16px 20px 20px;
  }

  /* ---------- RINGKASAN PRODUK ---------- */
  .pd-meta {
    margin: 0 0 6px;
    font-size: 12.5px;
    line-height: 1.6;
    color: #8a8f98;
  }

  .pd-meta__item {
    display: inline-block;
  }

  /* Pemisah lewat CSS supaya tidak ada titik menggantung saat sebuah item tidak dirender */
  .pd-meta__item + .pd-meta__item::before {
    content: '\00b7';
    margin: 0 8px;
    color: #c9ccd2;
  }

  .pd-desc {
    margin: 0;
    font-size: 13.5px;
    line-height: 1.65;
    color: #4a4a55;
    white-space: pre-line;
  }

  .pd-divider {
    height: 1px;
    margin: 18px 0;
    background: #eff0f3;
  }

  /* ---------- ACCORDION POLICY ---------- */
  .pd-accordion {
    margin-top: 14px;
    border-radius: 12px;
    background: #fff;
    overflow: hidden;
  }

  .pd-accordion__head {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 12px 14px;
    border: 0;
    background: transparent;
    text-align: left;
    cursor: pointer;
  }

  .pd-accordion__title {
    flex: 1 1 auto;
    font-size: 13.5px;
    font-weight: 500;
    color: #2c2c36;
  }

  .pd-accordion__body {
    padding: 0 14px 14px;
    font-size: 12px;
    line-height: 1.6;
    color: #6b6f77;
    animation: pd-reveal 0.25s ease-out;
  }

  .pd-accordion__body ul,
  .pd-accordion__body ol {
    margin: 0;
    padding-left: 18px;
  }

  .pd-chevron {
    flex-shrink: 0;
    color: #8a8f98;
    transition: transform 0.2s;
  }

  .pd-chevron--open {
    transform: rotate(180deg);
  }

  /* ---------- LANGKAH ---------- */
  .pd-section {
    margin-top: 22px;
  }

  .pd-step {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 0 0 10px;
    font-size: 14px;
    font-weight: 600;
    color: #16161d;
  }

  .pd-step__num {
    flex-shrink: 0;
    width: 22px;
    height: 22px;
    display: grid;
    place-items: center;
    border: 1px solid #ccc;
    border-radius: 50%;
    color: #9a9ea6;
    font-size: 11px;
  }

  /* Judul blok sekunder: tanpa nomor, bobot lebih ringan dari .pd-step */
  .pd-subhead {
    margin: 0 0 2px;
    font-size: 12.5px;
    font-weight: 500;
    color: #6b6f77;
  }

  .pd-hint {
    margin: 0 0 10px;
    font-size: 12px;
    line-height: 1.5;
    color: #9a9ea6;
  }

  /* ---------- KARTU BOOKING (TANGGAL + JUMLAH) ---------- */
  .pd-book-card {
    display: grid;
    grid-template-columns: 1fr 1fr;
    border-radius: 12px;
    background: #fff;
  }

  .pd-book-cell {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 0;
  }

  .pd-book-cell--qty {
    border-left: 1px solid #ccc;
  }

  /* Di layar sangat sempit stepper tidak muat berdampingan dengan tanggal */
  @media (max-width: 359px) {
    .pd-book-card {
      grid-template-columns: 1fr;
    }

    .pd-book-cell--qty {
      border-left: 0;
      border-top: 1px solid #ccc;
    }
  }

  /* .form-control bawaan bootstrap punya radius & background sendiri -> jangan sampai
     memotong sudut kartu (kartu tidak boleh overflow:hidden, dropdown kalender akan terpotong) */
  .pd-book-card .vue-daterange-picker .form-control.reportrange-text {
    background: transparent !important;
    border-radius: inherit;
  }

  /* Pemicu kalender cuma selebar setengah kartu -> dropdown dikunci ke tepi kiri kartu
     supaya tidak keluar dari modal saat dipusatkan ke pemicunya */
  .pd-book-cell .daterangepicker.openscenter {
    left: 0 !important;
    right: auto !important;
    -webkit-transform: none !important;
    transform: none !important;
  }

  .pd-book-cell .daterangepicker.openscenter::before {
    left: 24px;
    right: auto;
    margin-left: 0;
    margin-right: 0;
  }

  .pd-book-cell .daterangepicker.openscenter::after {
    left: 25px;
    right: auto;
    margin-left: 0;
    margin-right: 0;
  }

  .pd-book-row {
    padding: 12px 14px;
  }

  .pd-book-row--stack {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 8px;
    min-height: 74px;
    cursor: pointer;
  }

  .pd-book-cell--qty .pd-book-row--stack {
    cursor: default;
  }

  .pd-book-row__label {
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #9a9ea6;
  }

  .pd-book-row__value {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 15px;
    color: #16161d;
  }

  .pd-book-row__value .pd-chevron {
    margin-left: auto;
  }

  /* Ditempel ke #detail-form supaya menang atas padding .g-btn-lg global */
  #detail-form .pd-check {
    margin-top: 12px;
    height: 48px;
    padding: 0;
    border-radius: 12px;
  }

  /* ---------- STEPPER ---------- */
  .pd-stepper {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
  }

  /* Kolom kanan sempit: stepper melebar penuh supaya tombol +/- menempel ke tepi sel */
  .pd-stepper--wide {
    width: 100%;
    justify-content: space-between;
    gap: 4px;
  }

  .pd-stepper--wide .pd-stepper__value {
    min-width: 0;
    flex: 1;
  }

  .pd-stepper__btn {
    width: 30px;
    height: 30px;
    display: grid;
    place-items: center;
    border: 0;
    border-radius: 12px;
    background: var(--merchant-primary-color);
    color: #fff;
    cursor: pointer;
    transition: opacity 0.15s;
  }

  .pd-stepper__btn:hover:not(:disabled) {
    opacity: 0.85;
  }

  .pd-stepper__btn:disabled {
    background: #eef0f3;
    color: #b1b5c3;
    cursor: not-allowed;
  }

  .pd-stepper__value {
    display: flex;
    align-items: baseline;
    justify-content: center;
    gap: 5px;
    min-width: 86px;
  }

  .pd-stepper__num {
    min-width: 16px;
    text-align: center;
    font-size: 15px;
    color: #16161d;
  }

  .pd-stepper__unit {
    font-size: 13px;
    color: #6b6f77;
  }

  .pd-stepper--sm .pd-stepper__btn {
    width: 28px;
    height: 28px;
  }

  .pd-stepper--sm .pd-stepper__num {
    min-width: 22px;
  }

  /* Varian tenang untuk kontrol sekunder */
  .pd-stepper--ghost .pd-stepper__btn {
    background: #fff;
    color: #6b6f77;
  }

  .pd-stepper--ghost .pd-stepper__btn:disabled {
    background: #f7f8fa;
    color: #c4c8ce;
  }

  /* ---------- GUEST PER ITEM ---------- */
  .pd-guest-card {
    border-radius: 12px;
    overflow: hidden;
  }

  .pd-guest-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
  }

  .pd-guest-row + .pd-guest-row {
    border-top: 1px solid #ccc;
  }

  .pd-guest-badge {
    flex-shrink: 0;
    width: 22px;
    height: 22px;
    display: grid;
    place-items: center;
    border-radius: 50%;
    background: #f4f5f7;
    color: #8a8f98;
    font-size: 11px;
  }

  .pd-guest-name {
    flex: 1 1 auto;
    margin: 0;
    font-size: 13.5px;
    color: #2c2c36;
  }

  /* ---------- PILIHAN JAM ---------- */
  .pd-slot-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(96px, 1fr));
    gap: 8px;
  }

  .pd-slot {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;
    min-height: 44px;
    padding: 6px 14px;
    border-radius: 999px;
    background: #fff;
    cursor: pointer;
    transition: border-color 0.15s, background 0.15s;
  }

  .pd-slot:hover:not(:disabled) {
    border-color: var(--merchant-primary-color) !important;
  }

  .pd-slot__time {
    font-size: 15px;
    color: #16161d;
  }

  .pd-slot__note {
    font-size: 11px;
    color: #9a9ea6;
  }

  .pd-slot--active {
    background: var(--merchant-button-color);
    border-color: var(--merchant-button-color) !important;
  }

  .pd-slot--active .pd-slot__time,
  .pd-slot--active .pd-slot__note {
    color: #fff;
  }

  .pd-slot--full,
  .pd-slot--full:hover {
    background: #f4f5f7;
    cursor: not-allowed;
  }

  .pd-slot--full .pd-slot__time {
    color: #a0a4ab;
  }

  .pd-slot--full .pd-slot__note {
    color: #c98a8a;
  }

  @media (max-width: 400px) {
    .pd-slot-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  /* Style global timepicker pakai !important, jadi override-nya harus ikut !important */
  .pd-time .time-picker-manual input {
    height: 48px !important;
    padding: 0 14px !important;
    border: 1px solid #ccc !important;
    border-radius: 12px !important;
    font-size: 13.5px !important;
  }

  .pd-time__note {
    margin: 8px 0 0;
    font-size: 12px;
    color: #9a9ea6;
  }

  /* ---------- PILIHAN PLACE & GENDER ---------- */
  .pd-choice-row {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .pd-choice {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 44px;
    padding: 0 18px;
    border-radius: 999px;
    background: #fff;
    font-size: 13.5px;
    color: #2c2c36;
    cursor: pointer;
    transition: border-color 0.15s, background 0.15s, color 0.15s;
  }

  .pd-choice:hover {
    border-color: var(--merchant-primary-color) !important;
  }

  .pd-choice--active {
    background: var(--merchant-button-color);
    border-color: var(--merchant-button-color) !important;
    color: #fff;
  }

  .pd-toggle-card {
    border-radius: 12px;
    padding: 14px;
  }

  .pd-toggle-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    cursor: pointer;
  }

  .pd-toggle-label {
    margin: 0;
    font-size: 13.5px;
    color: #2c2c36;
  }

  .pd-toggle-card .pd-choice-row {
    margin-top: 14px;
    padding-top: 14px;
    border-top: 1px solid #ccc;
  }

  .pd-switch {
    position: relative;
    flex-shrink: 0;
    display: inline-block;
    width: 44px;
    height: 24px;
    border-radius: 999px;
    background: #dfe2e7;
    transition: background 0.2s;
  }

  .pd-switch__knob {
    position: absolute;
    top: 3px;
    left: 3px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #fff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    transition: transform 0.2s;
  }

  .pd-switch--on {
    background: var(--merchant-primary-color);
  }

  .pd-switch--on .pd-switch__knob {
    transform: translateX(20px);
  }

  /* ---------- EMPTY STATE ---------- */
  .pd-placeholder {
    margin-top: 22px;
    padding: 24px 20px;
    border-radius: 12px;
    text-align: center;
  }

  .pd-placeholder__icon {
    width: 44px;
    height: 44px;
    margin: 0 auto 12px;
    display: grid;
    place-items: center;
    border-radius: 50%;
    background: #f4f5f7;
    color: #9a9ea6;
  }

  .pd-placeholder__title {
    margin: 0 0 4px;
    font-size: 14px;
    font-weight: 600;
    color: #16161d;
  }

  .pd-placeholder__text {
    margin: 0;
    font-size: 12px;
    line-height: 1.6;
    color: #9a9ea6;
  }

  /* ---------- FOOTER HARGA ---------- */
  .pd-footer {
    flex: 0 0 auto;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px 16px;
    padding: 14px 20px;
    border-top: 1px solid #eceef1;
    background: #fff;
  }

  /* Blok harga boleh menyusut; kalau angkanya terlalu panjang, tombol turun baris
     alih-alih tergeser atau tertimpa */
  .pd-footer__price {
    flex: 1 1 auto;
    min-width: 0;
  }

  .pd-footer__label {
    margin: 0 0 2px;
    font-size: 12px;
    color: #9a9ea6;
  }

  .pd-footer__value {
    display: block;
    font-size: 24px;
    line-height: 1.15;
    color: #16161d;
    white-space: nowrap;
  }

  .pd-footer__sub {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    margin-top: 2px;
  }

  .pd-footer__old {
    font-size: 12px;
    color: #a0a4ab;
    text-decoration: line-through;
  }

  .pd-save-chip {
    padding: 2px 8px;
    border-radius: 999px;
    background: var(--merchant-button-color);
    color: #fff;
    font-size: 11px;
  }

  .pd-footer .pd-footer__btn {
    flex: 0 0 auto;
    height: 48px;
    padding: 0 24px;
    border-radius: 12px;
    white-space: nowrap;
  }

  @media (max-width: 575.98px) {
    .pd-header,
    .pd-body__inner,
    .pd-footer {
      padding-left: 16px;
      padding-right: 16px;
    }
    .pd-footer__price {
      width: 100%;
    }
    .pd-footer .pd-footer__btn {
      width: 100%;
    }
  }

  @keyframes pd-reveal {
    from {
      opacity: 0;
      transform: translateY(6px);
    }
    to {
      opacity: 1;
      transform: none;
    }
  }

  .pd-reveal {
    animation: pd-reveal 0.25s ease-out;
  }
</style>



// WEBPACK FOOTER //
// src/components/hotel/concierge/activity/ProductDetail.vue